import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[560px] overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20vibrant%20colorful%20comic%20book%20style%20background%20with%20abstract%20manga%20panels%2C%20dynamic%20action%20lines%2C%20speech%20bubbles%2C%20warm%20orange%20and%20coral%20gradient%2C%20energetic%20atmosphere%2C%20modern%20flat%20illustration%20with%20Japanese%20pop%20art%20influences%2C%20no%20text%2C%20no%20characters%2C%20abstract%20geometric%20composition&width=1920&height=800&seq=yaya-hero-bg&orientation=landscape"
        alt="丫丫漫画 - 免费在线漫画阅读平台"
        title="丫丫漫画 - 韩漫日漫国漫热门分类大全"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/15 to-black/45" />

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 text-center">
        <h1 className="text-3xl md:text-5xl font-heading text-background-50 mb-4 drop-shadow-lg">
          丫丫漫画
        </h1>
        <p className="text-base md:text-xl text-background-50/90 max-w-2xl mb-8 drop-shadow-md leading-relaxed">
          韩漫 · 日漫 · 国漫热门分类大全，免费全集下拉式阅读，好看的漫画一网打尽，追更收藏随时看
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3">
          <Link
            to="/category/korean"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer shadow-lg"
          >
            开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 font-medium text-sm hover:bg-background-50/30 transition-colors whitespace-nowrap cursor-pointer border border-background-50/30"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-10 flex items-center gap-6 text-background-50/80 text-sm">
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-background-50">3万+</span>
            <span>收录漫画</span>
          </div>
          <div className="w-px h-10 bg-background-50/30" />
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-background-50">500万+</span>
            <span>月活用户</span>
          </div>
          <div className="w-px h-10 bg-background-50/30" />
          <div className="flex flex-col items-center">
            <span className="text-xl md:text-2xl font-bold text-background-50">99.7%</span>
            <span>好评率</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent" />
    </section>
  );
}